export const ADD_CABINET = 'makeCustomCabinet/ADD_CABINET';
export const SET_SKELETON_MATERIAL = 'makeCustomCabinet/SET_SKELETON_MATERIAL';
export const SET_DOORS_MATERIAL = 'makeCustomCabinet/SET_DOORS_MATERIAL';
export const SET_HANDLES_MATERIAL = 'makeCustomCabinet/SET_HANDLES_MATERIAL';
export const SELECT_MANUFACTURER = 'makeCustomCabinet/SELECT_MANUFACTURER';
